/**
 * Basert på https://ckeditor.com/docs/ckeditor4/latest/guide/dev_autocomplete.html
 * Se fd.direktiver.AutoTagKonfigurasjon for konfigurasjon
 */

// Register the plugin in the editor.
CKEDITOR.plugins.add( 'autotag', {
    requires: 'autocomplete,textmatch',

    init: function( editor ) {

        //konfigurer plugin nå dette er klart
        editor.on( 'instanceReady', konfigurerPlugin);

        /** regexp brukt for å finne nøkkelord:søkestreng forekomst */
        var nøkkelordMatcher;

        function konfigurerPlugin() {
            var config = {
                textTestCallback: textTestCallback,
                dataCallback: dataCallback,
                throttle: 200,

                // Define the templates of the autocomplete suggestions dropdown and output text.
                itemTemplate: '<li data-id="{id}" class="ckeditor-autotag-{type}">{visningsnavn}</li>',
                outputTemplate: '<a href="{url}" class="ckeditor-autotag ckeditor-autotag-{type}" data-autotag="true" data-type="{type}" data-id="{id}">{typenavn}: {visningsnavn}</a> '
            };

            // Attach autocomplete to the editor.
            new CKEDITOR.plugins.autocomplete( editor, config );

            nøkkelordMatcher = byggNøkkelordMatcher();
        }

        //callback metoder kalt av autotag

        /** Called when the user types in the editor or moves the caret.
         * The range represents the caret position. */
        function textTestCallback(range) {
            // You do not want to autocomplete a non-empty selection.
            if (!range.collapsed) return null;

            // Use the text match plugin which does the tricky job of performing
            // a text search in the DOM. The "matchCallback" function should return
            // a matching fragment of the text.
            return CKEDITOR.plugins.textMatch.match( range, matchCallback );
        }

        /** Returns (through its callback) the suggestions for the current query. */
        function dataCallback(matchInfo, callback) {
            søk(matchInfo, callback)
        }


        //hjelpemetoder

        function søk(matchInfo, callback) {
            var parsetSøkestreng = nøkkelordMatcher.exec(matchInfo.query);

            editor.config.autotag_config.søk(parsetSøkestreng[1], parsetSøkestreng[2])
                .then(function (resultat) {
                    callback(resultat);
                });
        }

        /** Returns the position of the matching text.
         * It matches a word starting from the '#' character
         * up to the caret position. */
        function matchCallback(text, offset) {
            // Get the text before the caret.
            var left = text.slice(0, offset);
            var match = nøkkelordMatcher.exec(left);

            console.debug('matchCallback', text, offset, match ? match.index : '');

            return match ? {
                start: match.index,
                end: offset
            } : null;
        }

        /** regexp som matcher <nøkkelord>:<søkestreng med minst to tegn>
         * der søkestreng kan bestå av flere ord med blanke tegn i mellom */
        function byggNøkkelordMatcher(){
            var språk = autotagKonfigurasjon().språk;
            var nøkkelord = _(autotagKonfigurasjon().typer)
                .flatMap(function(v){return v.nøkkelord[språk]})
                .join('|');

            return new RegExp('('+nøkkelord+'):([^:]{2,})$', 'i');
        }


        function autotagKonfigurasjon(){
            return editor.config.autotag_config;
        }

    }
} );
